/**
 * The asset's own name. If no name, the brief's summary stands in, describing
 * the batch the agent generated rather than this ad. The brief's description
 * is deliberately not a further fallback: it runs long enough to swamp the one
 * line a card or a row gives a name.
 * If neither is provided, return "Untitled ad".
 */
export function adDisplayName({
  assetName,
  summary,
}: {
  assetName?: string | null;
  summary?: string | null;
}): string {
  return assetName?.trim() || summary?.trim() || "Untitled ad";
}
